var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_2030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.96997 6C6.76562 6 7.52868 5.68393 8.09129 5.12132C8.6539 4.55871 8.96997 3.79565 8.96997 3C8.96997 2.20435 8.6539 1.44129 8.09129 0.87868C7.52868 0.316071 6.76562 0 5.96997 0C5.17432 0 4.41126 0.316071 3.84865 0.87868C3.28604 1.44129 2.96997 2.20435 2.96997 3C2.96997 3.79565 3.28604 4.55871 3.84865 5.12132C4.41126 5.68393 5.17432 6 5.96997 6ZM4.89888 7.125C2.59028 7.125 0.719971 8.99531 0.719971 11.3039C0.719971 11.6883 1.03169 12 1.41606 12H10.5239C10.9083 12 11.22 11.6883 11.22 11.3039C11.22 8.99531 9.34966 7.125 7.04106 7.125H4.89888Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_2030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.d8611a3cd62f8ba768aef482b3e7d096.svg";
export { ForwardRef as ReactComponent };